module.exports = __webpack_public_path__ + "static/media/traffic-alert.b19eb72e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nxbus/traffic-alert.svg
// module id = 776
// module chunks = 0